exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".admin-component {\n  width: 1280px;\n  margin: 7px auto; }\n  .admin-component h1 {\n    color: #4a4a4a;\n    font-size: 20px; }\n  .admin-component div.ant-table-wrapper {\n    padding-top: 25px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Admin/components/FailedReportList/style.scss
// module id = 979
// module chunks = 0